import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import { Card } from 'reactstrap';

// One loading look across the dashboard: shimmering skeleton blocks in the shape of the content that is coming (a list of
// rows), instead of a spinner. The only spinner left is the small one inside a button that is saving (Loader below).

const ROW_WIDTHS = ['100%', '94%', '98%', '78%', '90%'];

// Rows of "avatar + two lines" - the shape of most lists and cards.
export const SkeletonRows = ({ rows = 3, avatar = true, style }) => (
  <div style={{ width: '100%', ...style }}>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '10px 4px' }}>
        {avatar && <Skeleton variant="circle" width={40} height={40} animation="wave" style={{ flexShrink: 0 }} />}
        <div style={{ flex: 1 }}>
          <Skeleton variant="text" width={ROW_WIDTHS[i % ROW_WIDTHS.length]} height={18} animation="wave" />
          <Skeleton variant="text" width="55%" height={14} animation="wave" />
        </div>
      </div>
    ))}
  </div>
);

// Plain bars - the shape of a table or a form while it loads.
export const SkeletonBars = ({ bars = 5, style }) => (
  <div style={{ width: '100%', ...style }}>
    {Array.from({ length: bars }).map((_, i) => (
      <Skeleton
        key={i}
        variant="rect"
        width={ROW_WIDTHS[i % ROW_WIDTHS.length]}
        height={20}
        animation="wave"
        style={{ borderRadius: 4, margin: '12px 0' }}
      />
    ))}
  </div>
);

// Whatever is loading: a block of skeleton rows. A small `size` (an inline spot, e.g. beside text) is still a tiny spinner.
export function CommonLoader({ size = 30, color, rows = 3 }) {
  if (size < 20) return <CircularProgress color={color || 'secondary'} size={size} style={{ marginRight: 10 }} />;
  return <SkeletonRows rows={rows} style={{ padding: '4px 0' }} />;
}

export const LoadingCard = ({ rows = 3 }) => (
  <Card style={{ marginTop: 10, marginBottom: 10 }}>
    <div style={{ padding: '10px 20px' }}>
      <SkeletonRows rows={rows} />
    </div>
  </Card>
);

// The spinner inside a button while it saves.
export default function Loader({ size = 24, style, color }) {
  return (
    <div style={{ display: 'flex', ...style }}>
      <CircularProgress color={color || 'secondary'} size={size} style={{ marginRight: 10 }} />
    </div>
  );
}
